import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class CustomerSearchResource extends BaseCamelCasedResource {
    pk() {
        return this.customerId || "";
    }
}
CustomerSearchResource.urlRoot = apiResourceUrl("customers");
export class PayoutCustomerSearchResource extends CustomerSearchResource {
}
PayoutCustomerSearchResource.urlRoot = apiResourceUrl("customers/search/payout");
export class SupplierCustomerSearchResource extends CustomerSearchResource {
}
SupplierCustomerSearchResource.urlRoot = apiResourceUrl("customers/suppliers");
//# sourceMappingURL=CustomerSearchResource.js.map